<div class="row">
  <div class="col-12" style="height: 90vh !important; overflow: auto;">
    <div class="row pt-1">
    <div class="col-12">
      <div class="d-flex justify-content-start pt-1 pb-1">
        <div class="px-1">
          <button type="button" class="btn btn-sm py-0 px-1"  (click)="Refresh()">
            <i class="fa1 fa fa-refresh" title="Refresh" aria-hidden="true"></i>
          </button>
        </div>
        <div class="px-1" *ngIf="canUseEditActions()">
          <button type="button" class="btn btn-sm bg-light border" [disabled]="!canUseEditActions()" (click)="Redirecttoquestionbody()">Question</button>

        </div>
        <div class="px-1" *ngIf="canUseEditActions()">
          <button type="button" class="btn btn-sm bg-light border" [disabled]="!canUseEditActions()" (click)="RedirecttoAnswerChoice()">Answers</button>

        </div>
        <div class="px-1" *ngIf="canUseNoteActions()">
          <button type="button" class="btn btn-sm bg-light border" [disabled]="!canUseNoteActions()" (click)="RedirecttoAnswerChoiceNote()">Answer Note</button>

        </div>
        <div class="px-1" *ngIf="canUseNoteActions()">
          <button type="button" class="btn btn-sm bg-light border" [disabled]="!canUseNoteActions()" (click)="RedirecttoSolutionHint()">Solution Hint</button>

        </div>
        <div class="px-1">
          <button type="button" class="btn btn-sm bg-light border" (click)="Previewclose()">Close</button>

        </div>

      </div>
    </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div style="border-bottom: 1px solid #c8c3c3;">

        </div>

      </div>

    </div>
      <div class="row pt-1">
        <div class="editor py-0">
        <div class="col-12" *ngIf="previewdetail.safehtmlStr!=null">
          <div  [innerHTML]="previewdetail.safehtmlStr"></div>
        </div>
      </div>
      </div>

      <div class="row" *ngIf="previewdetail.RightAnswer11!=null&&previewdetail.RightAnswer11!=''">
        <div class="editor pt-3">
        <div class="col-12">
          <div class="row" *ngIf="previewdetail.RightAnswer11">
            <div class="col-1 px-0 AnswerChoicelabel">

                Right Answer  :

            </div>

            <div class="col-10 px-1 AnswerChoicelabel1">

              <div  [innerHTML]="previewdetail.RightAnswer11"></div>

            </div>

          </div>
        </div>


      </div>
    </div>
    <div class="row" *ngIf="previewdetail.WrongAnswer11">
      <div class="editor">
      <div class="col-12">
        <div class="row" *ngIf="previewdetail.WrongAnswer11">
          <div class="col-1 px-0 AnswerChoicelabel">

              Wrong Answer  :

          </div>

          <div class="col-10 px-1 AnswerChoicelabel1">

            <div  [innerHTML]="previewdetail.WrongAnswer11"></div>

          </div>

        </div>
      </div>


    </div>
  </div>
    <div class="row" *ngIf="previewdetail.WrongAnswer22">
      <div class="editor ">
      <div class="col-12">
        <div class="row" *ngIf="previewdetail.WrongAnswer22">
          <div class="col-1 px-0 AnswerChoicelabel">

            Wrong Answer  :

          </div>

          <div class="col-10 px-1 AnswerChoicelabel1">

            <div  [innerHTML]="previewdetail.WrongAnswer22"></div>

          </div>

        </div>
      </div>


    </div>
  </div>
  <div class="row" *ngIf="previewdetail.WrongAnswer33">
    <div class="editor">
    <div class="col-12">
      <div class="row" *ngIf="previewdetail.WrongAnswer33">
        <div class="col-1 px-0 AnswerChoicelabel">

          Wrong Answer  :

        </div>

        <div class="col-10 px-1 AnswerChoicelabel1">

          <div  [innerHTML]="previewdetail.WrongAnswer33"></div>

        </div>

      </div>
    </div>


  </div>
</div>
<div class="row" *ngIf="previewdetail.WrongAnswer44">
  <div class="editor">
  <div class="col-12">
    <div class="row" *ngIf="previewdetail.WrongAnswer44">
      <div class="col-1 px-0 AnswerChoicelabel">

        Wrong Answer  :

      </div>

      <div class="col-10 px-1 AnswerChoicelabel1">

        <div  [innerHTML]="previewdetail.WrongAnswer44"></div>

      </div>

    </div>
  </div>


</div>
</div>
<div class="row" *ngIf="previewdetail.WrongAnswer55">
  <div class="editor ">
  <div class="col-12">
    <div class="row" *ngIf="previewdetail.WrongAnswer55">
      <div class="col-1 px-0 AnswerChoicelabel">

        Wrong Answer  :

      </div>

      <div class="col-10 px-1 AnswerChoicelabel1">

        <div  [innerHTML]="previewdetail.WrongAnswer55"></div>

      </div>

    </div>
  </div>


</div>
</div>
<div class="row" *ngIf="previewdetail.WrongAnswer66">
  <div class="editor ">
  <div class="col-12">
    <div class="row" *ngIf="previewdetail.WrongAnswer66">
      <div class="col-1 px-0 AnswerChoicelabel">

        Wrong Answer  :

      </div>

      <div class="col-10 px-1 AnswerChoicelabel1">

        <div  [innerHTML]="previewdetail.WrongAnswer66"></div>

      </div>

    </div>
  </div>


</div>
</div>

<div class="row" *ngIf="previewdetail.WrongAnswer77!=''">
  <div class="editor ">
  <div class="col-12">
    <div class="row" *ngIf="previewdetail.WrongAnswer77">
      <div class="col-1 px-0 AnswerChoicelabel">

        Wrong Answer  :

      </div>

      <div class="col-10 px-1 AnswerChoicelabel1">

        <div  [innerHTML]="previewdetail.WrongAnswer77"></div>

      </div>

    </div>
  </div>


</div>
</div>
<div class="row">
  <div class="col-12">
    <div style="border-bottom: 1px solid #c8c3c3;">

    </div>

  </div>

</div>
<div class="row" *ngIf="previewdetail.RightAnswer1">
  <div class="col-12">
    <div class="d-flex pt-1 pb-1">

      <div class="px-1" *ngIf="previewdetail.RightAnswer1.Answer_SolutionHintflag">
        <a [routerLink]="['./']" *ngIf="previewdetail.RightAnswer1.Answer_SolutionHintflag" (click)="SolutionHintpopup(previewdetail.RightAnswer1)"  class="card-link Answer-card-link" >Solution Hint</a>

      </div>

    </div>

  </div>

</div>
<div class="row" >
  <div class="editor py-1">
  <div class="col-12" >
    <div  class="editor" [innerHTML]="solutionhint"></div>
  </div>
</div>
</div>
<div class="row" *ngIf="previewdetail.RightAnswer1">
  <div class="col-12">
    <div class="d-flex pt-1 pb-1">

      <div class="px-1" *ngIf="previewdetail.RightAnswer1.AnswerNoteflag">
        <a [routerLink]="['./']" *ngIf="previewdetail.RightAnswer1.AnswerNoteflag" (click)="AnswerNotepopup(previewdetail.RightAnswer1)"  class="card-link Answer-card-link" >Answer Note</a>
      </div>
    </div>

  </div>

</div>
<div class="row pt-1">
  <div class="editor py-1">
  <div class="col-12" >
    <div  class="editor" [innerHTML]="Answernote"></div>
  </div>
</div>
</div>

<!-- <div class="row pt-1">
  <div class="col-12">
    <div class="d-flex justify-content-center pt-1 pb-1">

      <div class="px-1">
        <button type="button" class="btn btn-sm bg-light border" (click)="Previewclose()">Close</button>

      </div>
    </div>
  </div>
</div> -->
</div>
</div>



<div class="modal fade  show Model_popup1" *ngIf="AnswerChoiceNotePopup">
  <div class="modal-dialog modal-dialog-centered modal-dialog-Edit1">
    <div class="modal-content">
      <div class="modal-header border Page-Header p-1 py-0">
        <h6 class="HeadContent" id="QuestionTemplatetitle">Preview Answer Choice Note</h6>
        <button type="button" class="close" (click)="AnswerChoiceNote()"
          style="padding-right: 20px;font-size: 30px;outline: 0;">
          <span aria-hidden="true">&times;</span></button>
      </div>

      <div class="modal-body px-3 py-0">
        <div class="row">

          <div class="col-12" style="height: 55vh !important; overflow: auto;">
            <div class="row pt-3">
              <div class="col-12"  style="min-height: 10vh !important; overflow: auto;">
                    <div  [innerHTML]="Answernote"></div>
              </div>
            </div>

        </div>
        <div class="col-12">
          <div class="d-flex justify-content-center pt-1 pb-1">

            <div class="px-1">
              <button type="button" class="btn btn-sm bg-light border" (click)="AnswerChoiceNote()">Close</button>

            </div>
          </div>
        </div>



      </div>
    </div>
  </div>
</div>
</div>
